import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@blueprintjs/core';
import { ShowHide } from 'components/layout';

const statusDisplay = {
    Rectified: { icon: "tick-circle", className: "text-intent-success", text: "Rectified" },
    "Not Rectified": { icon: "delete", className: "text-intent-danger", text: "Not rectified" },
    Monitored: { icon: "search", className: "text-intent-warning", text: "Monitored" }
};

export function DefectStatus(
    {
        status = "Open",
        loading = false
    }
) {
    const display = statusDisplay[status] ?? { icon: null, className: null, text: status };

    return (
        <span className={classNames("defect-status nowrap inline-items", display.className, { "bp6-skeleton": loading })}>
            <ShowHide
                evaluator={display.icon != null}
                show={(<Icon icon={display.icon} />)}
            />
            <span>{display.text}</span>
        </span>
    );
}

DefectStatus.propTypes = {
    status: PropTypes.string,
    loading: PropTypes.bool
};
